import useWalletUnit from '~/client/hooks/currency/useWalletUnit';

const useGetInGameCurrencyValue = () => {
  const walletUnit = useWalletUnit();
  const getInGameCurrencyValue = (inGameCurrency?: string) =>
    inGameCurrency === walletUnit ? undefined : inGameCurrency;

  return { getInGameCurrencyValue };
};

export default useGetInGameCurrencyValue;
